<template>
  <div class="page video-page">
    <van-nav-bar :title="$t('video.video')" class="nav-bar nav-bar-gradient">
      <template #right>
        <van-icon name="chat-o" size="20" color="#fff" @click="toLogin('/ServiceOnline')" />
      </template>
    </van-nav-bar>

    <van-tabs v-model="active" title-inactive-color="var(--muted)" title-active-color="var(--primary)"
      line-height="4px" line-width="32px" @change="onChange">
      <van-tab :title="item.name" :name="item.id"
        v-for="(item,index) in videolitem" :key="item.id">
        <template #title v-if="index==0">
          <div style="display: flex; align-items: center;">
            <div>{{ item.name }}</div>
          </div>
        </template>

        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" @load="onLoad">
            <div class="video-grid">
              <div class="video-card" v-for="(i,key) in data" :key="key" @click="toPlayVideo(i.id)">
                <div class="video-cover">
                  <img :src="i.vod_pic" class="video-pic" />
                </div>
                <div class="video-meta">
                  <span class="video-name">{{ i.vod_name }}</span>
                  <span class="video-count">{{$t("video.play")}} :{{ i.count }}</span>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>

    <div style="height: 55px;"></div>
  </div>
</template>

<script>
  import { Toast } from "vant";
  export default {
    data() {
      return {
        list: [],
        loading: false,
        finished: false,
        refreshing: false,
        videolitem: [],
        data: [],
        page: 1,
        id: 888,
        active: 0,
      };
    },
    methods: {
      onRefresh() {
        this.finished = false;
        this.loading = true;
        this.onLoad(true);
      },
      onLoad(isRefresh = false) {
        if (isRefresh) {
          this.page = 1;
          this.data = [];
        }
        this.getVideoList().then(() => {
          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
            Toast("Refresh successful");
          }
        });
      },
      onChange(name) {
        this.id = name;
        this.finished = false;
        this.loading = true;
        this.onLoad(true);
      },
      toPlayVideo(id) {
        this.$router.push({ path: "/PlayVideo", query: { id } });
      },
      getVideoList() {
        return new Promise((resolve, reject) => {
          this.$http({
            method: "get",
            data: { id: this.id, page: this.page },
            url: "video_list",
          }).then((res) => {
            if (res.data && res.data.data && res.data.data.length > 0) {
              this.data = this.data.concat(res.data.data);
              this.page++;
              resolve();
            } else {
              this.finished = true;
              resolve();
            }
          }).catch((error) => {
            console.error("Error fetching video list:", error);
            this.loading = false;
            this.refreshing = false;
            reject(error);
          });
        });
      },
      toLogin(str) {
        this.$router.push({ path: str });
      },
      getVideoClass() {
        this.$http({
          method: "get",
          url: "video_class",
        }).then((res) => {
          const lanng = localStorage.getItem("lang");
          this.videolitem = res.data;
          this.videolitem.forEach((item) => {
            const parts = item.name.split(",");
            lanng == 'kr' ? item.name = parts[0] : lanng == 'en' ? item.name = parts[1] :
              lanng == 'ja' ? item.name = parts[2] : item.name = parts[3]
          });
        });
      },
    },
    created() {
      this.getVideoClass();
    },
  };
</script>

<style scoped>
.video-page {
  background: #f6f5f2;
  padding-bottom: 60px;
}

.video-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px;
}

.video-card {
  width: calc(50% - 6px);
  background: rgba(255,255,255,.74);
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-soft);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255,255,255,.72);
  cursor: pointer;
  transition: transform .2s ease;

  &:active {
    transform: scale(.97);
  }
}

.video-cover {
  width: 100%;
  height: 180px;
  overflow: hidden;
  border-radius: var(--radius-md) var(--radius-md) 0 0;
}

.video-pic {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-meta {
  padding: 10px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.video-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 60%;
}

.video-count {
  font-size: 12px;
  color: var(--hint);
}
::v-deep .van-tabs__wrap {
  display: none !important;
}
</style>